import { navigate, useParams } from '@gatsbyjs/reach-router';

const JobRedirectPage = () => {
  const { jobName } = useParams();
  let redirectPageUrl = "";

  if (jobName !== "" && jobName !== undefined) {
    redirectPageUrl = "pendingenrollment";
  }

  navigate("/" + redirectPageUrl, { replace: true });

  return <></>;
};

export default JobRedirectPage;
